import { FormErrors, getFieldError, getFormErrorMessages } from '../utils/formValidation';

interface FieldErrorProps {
  errors: FormErrors;
  fieldName: string;
}

export function FieldError({ errors, fieldName }: FieldErrorProps) {
  const error = getFieldError(errors, fieldName);

  if (error === null) {
    return null;
  }

  return (
    <span className="form-field-error" id={getFieldErrorId(fieldName)}>
      {error}
    </span>
  );
}

interface FormErrorSummaryProps {
  errors: FormErrors;
  message?: string | null;
}

export function FormErrorSummary({ errors, message = null }: FormErrorSummaryProps) {
  const messages = getFormErrorMessages(errors);

  if (messages.length === 0 && message === null) {
    return null;
  }

  return (
    <div className="form-error-summary" role="alert">
      <strong>Проверьте введённые данные</strong>
      {message !== null ? <p>{message}</p> : null}
      {messages.length > 0 ? (
        <ul>
          {messages.map((errorMessage) => <li key={errorMessage}>{errorMessage}</li>)}
        </ul>
      ) : null}
    </div>
  );
}

export function getFieldErrorId(fieldName: string): string {
  return `field-error-${fieldName.replace(/[^a-zA-Z0-9_-]/g, '-')}`;
}

export function getFieldValidationProps(errors: FormErrors, fieldName: string) {
  const error = getFieldError(errors, fieldName);

  return {
    'aria-describedby': error === null ? undefined : getFieldErrorId(fieldName),
    'aria-invalid': error !== null,
  };
}
